module.exports = __webpack_public_path__ + "files/1aa390dba4abdf17268ee1e32d57c59c.png";